import Component, { Topic } from 'component';
customElements.define('x-cart-indicator', class extends Component {
    constructor() {
        super();
    }
    setCount(count) {
        if (!this.hasAttribute('data-cart-count')) return;
        const itemCount = Number(count) || 0;
        this.textContent = itemCount > 99 ? '99+' : String(itemCount);
    }
    render() {
        this.setCount(this.getAttribute('data-cart-count'));
        this.sub(Topic.CART_UPDATE, ({ data }) => {
            if (data) {
                const { indicator, itemCount } = data;
                this.toggleAttribute('hidden', !indicator);
                this.setCount(itemCount);
            }
        }, { global: true });
    }
});
